import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, DollarSign, Settings, Users, FileText, CreditCard, Globe, Shield } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

const Configuracoes = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const isAdmin = user?.permission_level === 'admin' || user?.permission_level === 'super_admin';

  const configuracoes = [
    {
      id: 'faturamento',
      title: 'Faturamento',
      description: 'Configure regras de cálculo de datas e parcelamentos',
      icon: DollarSign,
      color: 'bg-green-500',
      path: '/configuracoes/faturamento'
    },
    {
      id: 'usuarios',
      title: 'Usuários',
      description: 'Gerencie usuários e permissões do sistema',
      icon: Users,
      color: 'bg-blue-500',
      path: '/configuracoes/usuarios'
    },
    {
      id: 'sistema',
      title: 'Sistema',
      description: 'Configurações gerais do sistema',
      icon: Settings,
      color: 'bg-gray-500',
      path: '/configuracoes/sistema'
    },
    {
      id: 'dados-bancarios',
      title: 'Dados Bancários',
      description: 'Configure suas contas para recebimento de comissões',
      icon: CreditCard,
      color: 'bg-blue-600',
      path: '/configuracoes/dados-bancarios'
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      description: 'Configure templates e formatos de relatórios',
      icon: FileText,
      color: 'bg-purple-500',
      path: '/configuracoes/relatorios'
    },
    {
      id: 'catalogo-online',
      title: 'Catálogo Online',
      description: 'Configure a página pública do catálogo online',
      icon: Globe,
      color: 'bg-teal-500',
      path: '/configuracoes/catalogo-online'
    },
    {
      id: 'catalogo-detalhado',
      title: 'Catálogo Detalhado',
      description: 'Personalize colunas e totais do catálogo detalhado com fazenda fictícia',
      icon: FileText,
      color: 'bg-indigo-500',
      path: '/configuracoes/catalogo-detalhado'
    },
    ...(isAdmin ? [{
      id: 'auditoria',
      title: 'Log de Auditoria',
      description: 'Visualize o histórico de operações financeiras',
      icon: Shield,
      color: 'bg-amber-500',
      path: '/configuracoes/auditoria'
    }] : []),
  ];

  return (
    <div>
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
            <p className="text-gray-600 mt-1">
              Gerencie as configurações do sistema
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {configuracoes.map((config) => {
            const Icon = config.icon;
            return (
              <button
                key={config.id}
                onClick={() => navigate(config.path)}
                className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow text-left"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-lg ${config.color}`}>
                    <Icon size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {config.title}
                    </h3>
                  </div>
                </div>
                <p className="text-gray-600 text-sm">
                  {config.description}
                </p>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Configuracoes;